import Dashboard from '../components/Dashboard/Dashboard';
import { TitleContext } from '../components/Context'
import { useContext, useEffect } from 'react';

const DashboardPage = () => {

  const { value, setTitle } = useContext(TitleContext);

  useEffect(() => {
    setTitle('Observatorio Marino/Costero');
  }, [setTitle]);

  return <Dashboard />;
};

export default DashboardPage;
